/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../baseclasses/dataservicebase.ts" />

module Meevo.Components.Controls {

    export class MeevoOrderedList implements angular.IDirective {
        restrict = "E";
        required = "ngModel";
        scope = {
            ngModel: '=',
            identityService: '=',
            baseEndPoint: '@',
            criteria: "=?",
            ngDisabled: "=?"
        }
        templateUrl = 'app/components/controls/orderedListTemplate.html'

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {
            let that = this;
            let request: any;
            if (scope.identityService.identity.centralOfficeId == scope.identityService.locationId) {
                request = {
                    criteria: {
                        includeActive: true,
                        includeDeleted: false,
                        includeInactive: false,
                        location: null,
                        coSearchType: 0
                    },
                    itemsPerPage: 250
                }
            }
            else {
                request = {
                    criteria: {
                        includeActive: true,
                        includeDeleted: false,
                        includeInactive: false,
                        coSearchType: 1,
                        coBusinessTypeId: null,
                        coFilterByLocationId: scope.identityService.locationId,
                        coSearchResultFilter: 1
                    },
                    itemsPerPage: 250
                }
            }          

            if (scope.criteria) {
                request.criteria = scope.criteria;
            }

            if (!scope.ngModel){
                scope.ngModel = [];
            }
            
            scope.getServiceCategories = function () {
                that.dataService.getListPaged("serviceCategory", request).then(function (response: any) {
                    scope.serviceCategories = _.filter(response, (item: any) => {
                        let matchingItems = _.filter(scope.ngModel, (category: any) => {
                            if (item.displayName == category.displayName) {
                                return true
                            }
                            return false
                        });
                        if (matchingItems.length != 0) {
                            return false;
                        }
                        return true;
                    })
                    scope.serviceCategories = response;
                })
            }
           scope.getServiceCategories();
            
            scope.serviceCategories;

            scope.moveUp = (category) => {
                if (!scope.ngDisabled){
                    let index = _.findIndex(scope.ngModel, function (item: any) {
                        if (category.id == item.id) {
                            return true
                        }
                        else {
                            return false
                        }
                    });
                    scope.ngModel.splice(index - 1, 0, scope.ngModel.splice(index, 1)[0])
                }
                
            };

            scope.moveDown = (category) => {
                if (!scope.ngDisabled) {
                    let index = _.findIndex(scope.ngModel, function (item: any) {
                        if (category.id == item.id) {
                            return true
                        }
                        else {
                            return false
                        }
                    });
                    scope.ngModel.splice(index + 1, 0, scope.ngModel.splice(index, 1)[0])
                }
                
            };

            scope.addCategory = (category) => {
                if (!scope.ngDisabled){
                    let alreadyExists = false;
                    _.find(scope.ngModel, function (item: any) {
                        if (item.displayName == category.displayName) {
                            alreadyExists = true;
                            return alreadyExists;
                        }
                        else {
                            return false;
                        }
                    })
                    if (!alreadyExists) {
                        scope.ngModel.push(category);
                        scope.getServiceCategories();
                    }
                }
                
            }
            scope.isBottom = (category) => {
                if (scope.ngModel[scope.ngModel.length - 1].id != category.id) {
                    return false;
                }
                else {
                    return true;
                }
            }
            scope.isTop = (category) => {
                if (scope.ngModel[0].id != category.id) {
                    return false;
                }
                else {
                    return true;
                }
            }
            scope.removeCategory = (category) => {
                if (!scope.ngDisabled) {
                    let index = _.findIndex(scope.ngModel, function (item: any) {
                        if (category.id == item.id) {
                            return true
                        }
                        else {
                            return false
                        }
                    });
                    scope.ngModel.splice(index, 1);
                    scope.getServiceCategories();
                }
                
            }
            /*  used to show ordering and delete controls  */
            scope.hasEditPermision = (item) => {
                //if (scope.identityService.identity.centralOfficeId != scope.identityService.locationId && (item.homeLocationId != scope.identityService.locationId && item.ownedByLocationId != scope.identityService.locationId)) {
                if (scope.identityService.identity.centralOfficeId != scope.identityService.locationId && !scope.matchId(item, scope.identityService.locationId)) {
                    return false
                }
                else {
                    return true
                }
            }
            scope.shouldBeVisible = (item) => {
              if (scope.matchId(item, scope.identityService.identity.centralOfficeId)) {
                return true;
              } else if (scope.matchId(item, scope.identityService.locationId)) {
                return true;
              } else {
                return false;
              }
            }
            scope.save = () => {
                this.dataService.add(scope.baseEndpoint, scope.ngModel);
            }

            scope.matchId = (item, id) => {
                return item.homeLocationId === id || item.atLocationId === id || item.ownedByLocationId === id || item.homeLocationId === 0;
            }
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoOrderedList(dataService);
            }

            directive.$inject = ['meevo.components.common.DataService'];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoOrderedList", MeevoOrderedList.factory());

}